import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@cargomatic/ui';

import { withTranslation } from 'react-i18next';
import LocationPairForm from './LocationPairForm';

class CreateLocationPairModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    locationPair: PropTypes.object,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  getLabel = () => {
    const { t } = this.props;
    if (!this.props.locationPair) {
      return t('CREATE_LOCATION_PAIR');
    }
    return t('EDIT_LOCATION_PAIR');
  };
  handleSave = (locationPair) => this.props.onSave(locationPair);

  handleHide = () => this.props.onHide();

  render() {
    return (
      <Dialog open={this.props.show} onOpenChange={this.props.onHide}>
        <DialogContent className="sm:max-w-[900px]">
          <DialogHeader>
            <DialogTitle>{this.getLabel()}</DialogTitle>
          </DialogHeader>
          <LocationPairForm
            locationPair={this.props.locationPair}
            onCancel={this.handleHide}
            onSave={this.handleSave}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

export default withTranslation()(CreateLocationPairModal);
